export enum GtmInsuranceType {
    Transport = 'transport',
    Travel = 'travel',
    PersonalAccidents = 'personal_accidents',
}
